import { render, staticRenderFns } from "./VariableSectorSanitari.vue?vue&type=template&id=5008e07c&scoped=true&"
import script from "./VariableSectorSanitari.vue?vue&type=script&lang=js&"
export * from "./VariableSectorSanitari.vue?vue&type=script&lang=js&"
import style0 from "./VariableSectorSanitari.vue?vue&type=style&index=0&id=5008e07c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5008e07c",
  null
  
)

export default component.exports